package de.xtl.retroguide.lobby

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.safeDrawingPadding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Button
import androidx.compose.material3.FilterChip
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Surface
import androidx.compose.material3.Switch
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.semantics.contentDescription
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.unit.dp
import de.xtl.retroguide.AppTheme
import de.xtl.retroguide.InvitationShareButton
import de.xtl.retroguide.join.JoinSessionAction
import de.xtl.retroguide.join.JoinSessionError
import de.xtl.retroguide.join.JoinSessionState
import de.xtl.retroguide.protocol.LobbyParticipant
import de.xtl.retroguide.protocol.ParticipantRole
import de.xtl.retroguide.protocol.QuestionWidget
import retroguide.app.shared.generated.resources.dot_voting_budget_label
import retroguide.app.shared.generated.resources.dot_voting_source_missing
import retroguide.app.shared.generated.resources.dot_voting_source_option
import retroguide.app.shared.generated.resources.dot_voting_source_label
import de.xtl.retroguide.join.votingSourceCandidates
import de.xtl.retroguide.join.effectiveVoteSource
import de.xtl.retroguide.protocol.RetroPhase
import de.xtl.retroguide.protocol.SessionAccess
import de.xtl.retroguide.protocol.SessionSnapshot
import org.jetbrains.compose.resources.stringResource
import retroguide.app.shared.generated.resources.Res
import retroguide.app.shared.generated.resources.leave_action
import retroguide.app.shared.generated.resources.lobby_connecting
import retroguide.app.shared.generated.resources.lobby_waiting
import retroguide.app.shared.generated.resources.moderator_badge
import retroguide.app.shared.generated.resources.moderator_lobby_title
import retroguide.app.shared.generated.resources.participant_count
import retroguide.app.shared.generated.resources.participant_lobby_title
import retroguide.app.shared.generated.resources.question_label
import retroguide.app.shared.generated.resources.question_placeholder
import retroguide.app.shared.generated.resources.question_widget_battery
import retroguide.app.shared.generated.resources.question_widget_label
import retroguide.app.shared.generated.resources.question_widget_text
import retroguide.app.shared.generated.resources.question_widget_weather
import retroguide.app.shared.generated.resources.question_widget_sailboat
import retroguide.app.shared.generated.resources.question_widget_mad_sad_glad
import retroguide.app.shared.generated.resources.question_widget_starfish
import retroguide.app.shared.generated.resources.question_widget_four_l
import retroguide.app.shared.generated.resources.question_widget_roti
import retroguide.app.shared.generated.resources.question_widget_hot_air_balloon
import retroguide.app.shared.generated.resources.question_widget_speedcar
import retroguide.app.shared.generated.resources.question_widget_kalm
import retroguide.app.shared.generated.resources.question_widget_daki
import retroguide.app.shared.generated.resources.question_widget_team_radar
import retroguide.app.shared.generated.resources.question_widget_dot_voting
import retroguide.app.shared.generated.resources.question_widget_action_items
import retroguide.app.shared.generated.resources.question_timer_label
import retroguide.app.shared.generated.resources.question_timer_enabled_label
import retroguide.app.shared.generated.resources.question_timer_supporting_text
import retroguide.app.shared.generated.resources.question_answer_visibility_label
import retroguide.app.shared.generated.resources.add_question_action
import retroguide.app.shared.generated.resources.download_markdown_dialog_action
import retroguide.app.shared.generated.resources.session_code_heading
import retroguide.app.shared.generated.resources.start_question_action
import retroguide.app.shared.generated.resources.participant_names_label
import retroguide.app.shared.generated.resources.participant_names_supporting_text
import retroguide.app.shared.generated.resources.save_participant_names_action
import retroguide.app.shared.generated.resources.session_ended_dialog_action
import retroguide.app.shared.generated.resources.session_ended_message
import retroguide.app.shared.generated.resources.session_ended_title
import retroguide.app.shared.generated.resources.share_retro_dialog_action
import retroguide.app.shared.generated.resources.error_action_rejected
import retroguide.app.shared.generated.resources.error_connection
import retroguide.app.shared.generated.resources.invitation_link_label
import retroguide.app.shared.generated.resources.invitation_link_supporting_text

@Composable
fun ModeratorLobbyScreen(
    state: JoinSessionState,
    onAction: (JoinSessionAction) -> Unit,
) {
    val participants = state.session?.participants.orEmpty()
    Surface(Modifier.fillMaxSize()) {
        Box(
            modifier = Modifier.fillMaxSize().safeDrawingPadding().verticalScroll(rememberScrollState()),
            contentAlignment = Alignment.TopCenter,
        ) {
            Column(
                modifier = Modifier
                    .widthIn(max = 412.dp)
                    .fillMaxWidth()
                    .padding(horizontal = 24.dp, vertical = 48.dp),
                verticalArrangement = Arrangement.spacedBy(16.dp),
            ) {
                Text(stringResource(Res.string.moderator_lobby_title), style = MaterialTheme.typography.titleLarge)
                Text(state.access?.title.orEmpty(), style = MaterialTheme.typography.bodyMedium)
                Text(
                    stringResource(Res.string.session_code_heading),
                    style = MaterialTheme.typography.labelLarge,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                )
                Text(state.sessionCode, style = MaterialTheme.typography.headlineMedium)
                OutlinedTextField(
                    value = state.invitationUrl,
                    onValueChange = {},
                    readOnly = true,
                    label = { Text(stringResource(Res.string.invitation_link_label)) },
                    supportingText = { Text(stringResource(Res.string.invitation_link_supporting_text)) },
                    modifier = Modifier.fillMaxWidth(),
                )
                InvitationShareButton(state, Modifier.fillMaxWidth())
                Text(
                    stringResource(Res.string.participant_count, participants.size),
                    style = MaterialTheme.typography.titleMedium,
                )
                if (state.session == null) {
                    Text(stringResource(Res.string.lobby_connecting))
                } else {
                    participants.forEach { participant ->
                        Row(
                            modifier = Modifier.fillMaxWidth().padding(vertical = 8.dp),
                            horizontalArrangement = Arrangement.spacedBy(16.dp),
                        ) {
                            Text(
                                participant.displayName,
                                style = MaterialTheme.typography.bodyLarge,
                                modifier = Modifier.weight(1f),
                            )
                            if (participant.role == ParticipantRole.MODERATOR) {
                                Text(
                                    stringResource(Res.string.moderator_badge),
                                    style = MaterialTheme.typography.labelLarge,
                                    color = MaterialTheme.colorScheme.primary,
                                )
                            }
                        }
                    }
                }
                OutlinedTextField(
                    value = state.participantNamesDraft,
                    onValueChange = { onAction(JoinSessionAction.OnParticipantNamesChange(it)) },
                    label = { Text(stringResource(Res.string.participant_names_label)) },
                    supportingText = { Text(stringResource(Res.string.participant_names_supporting_text)) },
                    minLines = 3,
                    enabled = !state.isLoading,
                    modifier = Modifier.fillMaxWidth(),
                )
                Button(
                    onClick = { onAction(JoinSessionAction.OnSaveParticipantNamesClick) },
                    enabled = state.canSaveParticipantNames,
                    modifier = Modifier.fillMaxWidth(),
                ) {
                    Text(stringResource(Res.string.save_participant_names_action))
                }
                LobbyError(state.error)
                state.questionDrafts.forEachIndexed { index, question ->
                    OutlinedTextField(
                        value = question,
                        onValueChange = { onAction(JoinSessionAction.OnQuestionChange(index, it)) },
                        label = { Text(stringResource(Res.string.question_label, index + 1)) },
                        placeholder = { Text(stringResource(Res.string.question_placeholder)) },
                        enabled = !state.isLoading,
                        modifier = Modifier.fillMaxWidth(),
                    )
                    Text(
                        stringResource(Res.string.question_widget_label),
                        style = MaterialTheme.typography.labelLarge,
                    )
                    FlowRow(
                        horizontalArrangement = Arrangement.spacedBy(8.dp),
                        verticalArrangement = Arrangement.spacedBy(8.dp),
                    ) {
                        QuestionWidget.entries.forEach { widget ->
                            FilterChip(
                                selected = state.questionWidgets[index] == widget,
                                onClick = { onAction(JoinSessionAction.OnQuestionWidgetChange(index, widget)) },
                                enabled = !state.isLoading,
                                label = {
                                    Text(
                                        stringResource(
                                            when (widget) {
                                                QuestionWidget.TEXT -> Res.string.question_widget_text
                                                QuestionWidget.BATTERY -> Res.string.question_widget_battery
                                                QuestionWidget.WEATHER -> Res.string.question_widget_weather
                                                QuestionWidget.SAILBOAT -> Res.string.question_widget_sailboat
                                                QuestionWidget.MAD_SAD_GLAD -> Res.string.question_widget_mad_sad_glad
                                                QuestionWidget.STARFISH -> Res.string.question_widget_starfish
                                                QuestionWidget.FOUR_L -> Res.string.question_widget_four_l
                                                QuestionWidget.ROTI -> Res.string.question_widget_roti
                                                QuestionWidget.HOT_AIR_BALLOON -> Res.string.question_widget_hot_air_balloon
                                                QuestionWidget.SPEEDCAR -> Res.string.question_widget_speedcar
                                                QuestionWidget.KALM -> Res.string.question_widget_kalm
                                                QuestionWidget.DAKI -> Res.string.question_widget_daki
                                                QuestionWidget.TEAM_RADAR -> Res.string.question_widget_team_radar
                                                QuestionWidget.DOT_VOTING -> Res.string.question_widget_dot_voting
                                                QuestionWidget.ACTION_ITEMS -> Res.string.question_widget_action_items
                                            },
                                        ),
                                    )
                                },
                            )
                        }
                    }
                    if (state.questionWidgets[index] == QuestionWidget.DOT_VOTING) {
                        DotVotingSetup(state, index, onAction)
                    }
                    val timerEnabledLabel = stringResource(Res.string.question_timer_enabled_label)
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.SpaceBetween,
                    ) {
                        Text(timerEnabledLabel, style = MaterialTheme.typography.bodyLarge)
                        Switch(
                            checked = state.questionTimerEnabled[index],
                            onCheckedChange = {
                                onAction(JoinSessionAction.OnQuestionTimerEnabledChange(index, it))
                            },
                            enabled = !state.isLoading,
                            modifier = Modifier.semantics { contentDescription = timerEnabledLabel },
                        )
                    }
                    if (state.questionTimerEnabled[index]) {
                        OutlinedTextField(
                            value = state.questionTimerDrafts[index],
                            onValueChange = { onAction(JoinSessionAction.OnQuestionTimerChange(index, it)) },
                            label = { Text(stringResource(Res.string.question_timer_label)) },
                            supportingText = { Text(stringResource(Res.string.question_timer_supporting_text)) },
                            singleLine = true,
                            enabled = !state.isLoading,
                            keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number),
                            modifier = Modifier.fillMaxWidth(),
                        )
                    }
                    val visibilityLabel = stringResource(Res.string.question_answer_visibility_label)
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.SpaceBetween,
                    ) {
                        Text(visibilityLabel, style = MaterialTheme.typography.bodyLarge)
                        Switch(
                            checked = state.questionAnswerVisibility[index],
                            onCheckedChange = {
                                onAction(JoinSessionAction.OnQuestionAnswerVisibilityChange(index, it))
                            },
                            enabled = !state.isLoading,
                            modifier = Modifier.semantics { contentDescription = visibilityLabel },
                        )
                    }
                }
                TextButton(
                    onClick = { onAction(JoinSessionAction.OnAddQuestionClick) },
                    enabled = state.canAddQuestion,
                    modifier = Modifier.align(Alignment.CenterHorizontally),
                ) {
                    Text(stringResource(Res.string.add_question_action))
                }
                Button(
                    onClick = { onAction(JoinSessionAction.OnStartRetroClick) },
                    enabled = state.canStartRetro,
                    modifier = Modifier.fillMaxWidth(),
                ) {
                    Text(stringResource(Res.string.start_question_action))
                }
                TextButton(
                    onClick = { onAction(JoinSessionAction.OnLeaveLobbyClick) },
                    modifier = Modifier.align(Alignment.CenterHorizontally),
                ) {
                    Text(stringResource(Res.string.leave_action))
                }
                LobbyError(state.error)
            }
        }
    }
}

@Composable
private fun ParticipantSessionEndedDialog(
    onAction: (JoinSessionAction) -> Unit,
) {
    AlertDialog(
        onDismissRequest = {},
        title = { Text(stringResource(Res.string.session_ended_title)) },
        text = { Text(stringResource(Res.string.session_ended_message)) },
        confirmButton = {
            TextButton(onClick = { onAction(JoinSessionAction.OnSessionEndedConfirmClick) }) {
                Text(stringResource(Res.string.session_ended_dialog_action))
            }
        },
        dismissButton = {
            Row {
                TextButton(onClick = { onAction(JoinSessionAction.OnDownloadRetroClick) }) {
                    Text(stringResource(Res.string.download_markdown_dialog_action))
                }
                TextButton(onClick = { onAction(JoinSessionAction.OnShareRetroClick) }) {
                    Text(stringResource(Res.string.share_retro_dialog_action))
                }
            }
        },
    )
}

@Composable
private fun LobbyError(error: JoinSessionError?) {
    val message = when (error) {
        JoinSessionError.CONNECTION -> Res.string.error_connection
        JoinSessionError.ACTION_REJECTED,
        JoinSessionError.NAME_UNAVAILABLE,
        JoinSessionError.RATE_LIMITED,
        -> Res.string.error_action_rejected
        else -> return
    }
    Text(
        text = stringResource(message),
        style = MaterialTheme.typography.bodySmall,
        color = MaterialTheme.colorScheme.error,
    )
}

@Composable
fun ParticipantLobbyScreen(
    state: JoinSessionState,
    onAction: (JoinSessionAction) -> Unit,
) {
    val participantCount = state.session?.participants?.size ?: 0
    Surface(Modifier.fillMaxSize()) {
        Box(
            modifier = Modifier.fillMaxSize().safeDrawingPadding().verticalScroll(rememberScrollState()),
            contentAlignment = Alignment.TopCenter,
        ) {
            Column(
                modifier = Modifier
                    .widthIn(max = 412.dp)
                    .fillMaxWidth()
                    .padding(horizontal = 24.dp, vertical = 48.dp),
                verticalArrangement = Arrangement.spacedBy(16.dp),
            ) {
                Text(stringResource(Res.string.participant_lobby_title), style = MaterialTheme.typography.titleLarge)
                Text(state.access?.title.orEmpty(), style = MaterialTheme.typography.bodyMedium)
                Text(
                    stringResource(Res.string.session_code_heading),
                    style = MaterialTheme.typography.labelLarge,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                )
                Text(state.sessionCode, style = MaterialTheme.typography.headlineMedium)
                if (!state.showSessionEndedDialog) {
                    InvitationShareButton(state, Modifier.fillMaxWidth())
                }
                Text(stringResource(Res.string.lobby_waiting), style = MaterialTheme.typography.bodyLarge)
                Text(
                    if (state.session == null) {
                        stringResource(Res.string.lobby_connecting)
                    } else {
                        stringResource(Res.string.participant_count, participantCount)
                    },
                    style = MaterialTheme.typography.bodyMedium,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                )
                TextButton(
                    onClick = { onAction(JoinSessionAction.OnLeaveLobbyClick) },
                    modifier = Modifier.align(Alignment.CenterHorizontally),
                ) {
                    Text(stringResource(Res.string.leave_action))
                }
            }
        }
    }
    if (state.showSessionEndedDialog) {
        ParticipantSessionEndedDialog(onAction)
    }
}

private val previewParticipants = listOf(
    LobbyParticipant("1", "Mara", ParticipantRole.MODERATOR),
    LobbyParticipant("2", "Alex", ParticipantRole.PARTICIPANT),
    LobbyParticipant("3", "Sam", ParticipantRole.PARTICIPANT),
)

private fun previewAccess(role: ParticipantRole) = SessionAccess(
    sessionCode = "7KD4MQ9P2X",
    participantId = if (role == ParticipantRole.MODERATOR) "1" else "2",
    accessToken = "preview-token",
    role = role,
    title = "Team-Retro",
)

private fun previewSession() = SessionSnapshot(
    sessionCode = "7KD4MQ9P2X",
    title = "Team-Retro",
    participants = previewParticipants,
    phase = RetroPhase.LOBBY,
)

@Preview
@Composable
private fun ModeratorLobbyScreenPreview() {
    val access = previewAccess(ParticipantRole.MODERATOR)
    AppTheme {
        ModeratorLobbyScreen(
            state = JoinSessionState(sessionCode = access.sessionCode, access = access, session = previewSession()),
            onAction = {},
        )
    }
}

@Preview
@Composable
private fun ParticipantLobbyScreenPreview() {
    val access = previewAccess(ParticipantRole.PARTICIPANT)
    AppTheme {
        ParticipantLobbyScreen(
            state = JoinSessionState(sessionCode = access.sessionCode, access = access, session = previewSession()),
            onAction = {},
        )
    }
}

@Preview
@Composable
private fun ParticipantSessionEndedDialogPreview() {
    val access = previewAccess(ParticipantRole.PARTICIPANT)
    AppTheme {
        ParticipantLobbyScreen(
            state = JoinSessionState(
                sessionCode = access.sessionCode,
                access = access,
                session = previewSession().copy(isEnded = true),
                showSessionEndedDialog = true,
            ),
            onAction = {},
        )
    }
}

@Composable
private fun DotVotingSetup(
    state: JoinSessionState,
    index: Int,
    onAction: (JoinSessionAction) -> Unit,
) {
    val candidates = state.votingSourceCandidates(index)
    val selected = state.effectiveVoteSource(index)
    Text(stringResource(Res.string.dot_voting_source_label), style = MaterialTheme.typography.labelLarge)
    if (candidates.isEmpty()) {
        Text(
            stringResource(Res.string.dot_voting_source_missing),
            style = MaterialTheme.typography.bodyMedium,
            color = MaterialTheme.colorScheme.error,
        )
    } else {
        FlowRow(
            horizontalArrangement = Arrangement.spacedBy(8.dp),
            verticalArrangement = Arrangement.spacedBy(8.dp),
        ) {
            candidates.forEach { source ->
                val question = state.questionDrafts[source]
                FilterChip(
                    selected = source == selected,
                    onClick = { onAction(JoinSessionAction.OnQuestionVoteSourceChange(index, source)) },
                    enabled = !state.isLoading,
                    label = {
                        Text(
                            stringResource(
                                Res.string.dot_voting_source_option,
                                source + 1,
                                if (question.length > 28) question.take(27) + "…" else question,
                            ),
                        )
                    },
                )
            }
        }
    }
    Text(stringResource(Res.string.dot_voting_budget_label), style = MaterialTheme.typography.labelLarge)
    FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
        (1..5).forEach { budget ->
            FilterChip(
                selected = state.questionVoteBudgets.getOrNull(index) == budget,
                onClick = { onAction(JoinSessionAction.OnQuestionVoteBudgetChange(index, budget)) },
                enabled = !state.isLoading,
                label = { Text(budget.toString()) },
            )
        }
    }
}

